import { render, staticRenderFns } from "./category-url-table.vue?vue&type=template&id=26ac5536&"
import script from "./category-url-table.vue?vue&type=script&lang=js&"
export * from "./category-url-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports